import { gql } from '@apollo/client'

export const connectTikTok = gql`
  mutation ConnectTikTok($code: String!) {
    connectTikTok(code: $code)
  }
`
